import './styles/scrollable-item-list.scss'

import React       from 'react'
import PropTypes   from 'prop-types'
import classnames  from 'classnames'

import { Loader } from 'semantic-ui-react'

import InfiniteScroll from 'react-infinite-scroller'

class ListLoader extends React.Component {
  render() {
    return (
      <div className="scrollable-list-loader" key={0}>
        <Loader key={'loader-0'} active inline  size='tiny' /> Loading ...
      </div>
    )
  }
}

class Item extends React.Component {
  static propTypes = {
    renderItem: PropTypes.func.isRequired,
    item:       PropTypes.object.isRequired,
  }

  state = {
    initted: false,
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ initted: true })
    }, 10)
  }

  render() {
    const { renderItem, item } = this.props
    const { initted } = this.state

    const className = classnames('item', { initted })

    return (
      <div className={className}>
        { renderItem(item) }
      </div>
    )
  }
}

export default class ScrollableItemList extends React.Component {
  static propTypes = {
    filter:          PropTypes.func,
    connection:      PropTypes.object,
    loadNextPage:    PropTypes.func.isRequired,
    renderNode:      PropTypes.func.isRequired,
    onConnection:    PropTypes.func,
    noDataComponent: PropTypes.object,
    useWindow:       PropTypes.bool,
  }

  constructor(props) {
    super(props)
    this.state = this.stateFromProps(props)
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.connection !== this.props.connection) {
      this.setState(this.stateFromProps(props))
    }
  }

  stateFromProps(props) {

    return {
      edges: props.connection
        ? props.connection.edges
        : [],
      hasMore: props.connection
        ? props.connection.pageInfo.hasNextPage
        : false,
    }
  }

  handleLoadMore = () => {
    if (!this.state.loading) {
      this.setState({ loading: true }, () => {
        const edges  = this.state.edges || []
        const cursor = edges.length > 0
          ? edges[edges.length - 1].cursor
          : ''

        if (this.state.hasMore) {
          this.props.loadNextPage(cursor).then((nextConnection) => {
            const edges   = this.state.edges.concat(nextConnection.edges)
            // Guard against request storms when server says hasNextPage=true
            // but returns an empty page.
            const hasMore = nextConnection.pageInfo.hasNextPage && nextConnection.edges.length > 0

            this.setState({ edges, hasMore, loading: false }, () => {
              const { onConnection } = this.props

              if (onConnection) {
                onConnection({
                  pageInfo: {
                    hasNextPage: nextConnection.pageInfo.hasNextPage,
                  },
                  edges,
                })
              }
            })
          })  
        }  
      })
    }
  }

  renderNoData = (noDataComponent) => {
    return (
      <div className="scrollable-item-list-no-data">
        <div className="message">
          { noDataComponent }
        </div>
      </div>
    )
  }

  render() {
    const { renderNode, filter, noDataComponent, useWindow } = this.props
    const { hasMore, edges } = this.state

    const xedges = edges && filter
      ? edges.filter(filter)
      : edges

    if (noDataComponent && !hasMore && edges.length === 0) {
      return this.renderNoData(noDataComponent)
    }

    return (
      <div className="scrollable-item-list" ref={(ref) => this.scrollParentRef = ref}>
        <InfiniteScroll
          pageStart={0}
          loadMore={this.handleLoadMore}
          hasMore={!filter && hasMore}
          useWindow={!!useWindow}
          loader={<ListLoader key='loader-key' />}
          getScrollParent={() => this.scrollParentRef}>
          {
            xedges.map(({ cursor, node }) => (
              node ? <Item key={`${node.id}-${cursor}`} item={node} renderItem={renderNode} /> : <div>Missing log...</div>
            ))
          }
        </InfiniteScroll>
      </div>
    )
  }
}